import { useCallback } from 'react';
import { resetStore, useTemporalStore } from '../../AppStore';

const useResetUI = () => {
  const { clear } = useTemporalStore();

  const resetUI = useCallback(() => {
    resetStore();
    clear();
    window.history.replaceState(null, '', window.location.pathname);
  }, []);

  return resetUI;
};

export default useResetUI;
